import { useFormikContext } from "formik";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../../../actions/arts";
import { getFormTypes } from "../../../../../actions/forms";
import { getUserRoles } from "../../../../../actions/users";
import FormikAutocomplete from "../../../../commons/formik/formikAutocomplete";
import FormikSwitch from "../../../../commons/formik/formikSwitch";
import CircularLoading from "../../../../commons/loadingData/circularLoading";
import { StyledArtFormConfiguration } from "../../../../styled/artFormConfiguration";

const FormConfigurationForm = ({ editing, loading, editingRole }) => {
  const dispatch = useDispatch();
  const { values } = useFormikContext();
  const arts = useSelector((state) => state.arts.list);
  const formTypes = useSelector((state) => state.forms.getFormTypes.data);
  const userRoles = useSelector((state) => state.users.roles.data);

  const roles = useMemo(() => {
    return userRoles.filter((role) => role.tipo !== "Sistema")
  }, [userRoles])

  return (
    <>
      {!loading ? (
        <>
          <StyledArtFormConfiguration.StyledHorizontalInput>
            <FormikAutocomplete
              disabled={editing}
              name="idArt" label="Art*"
              options={arts}
              getOptions={() => dispatch(getArts())}
            />
          </StyledArtFormConfiguration.StyledHorizontalInput>
          <StyledArtFormConfiguration.StyledHorizontalInput>
            <FormikAutocomplete
              disabled={editing}
              name="idRol"
              label="Rol*"
              options={roles}
              labelOption={(option) => option.tipo}
              renderOption={(option) => option.tipo}
              getOptions={() => dispatch(getUserRoles())}
            />
          </StyledArtFormConfiguration.StyledHorizontalInput>
          {!editingRole && (
            <StyledArtFormConfiguration.StyledHorizontalInput>
              <FormikAutocomplete
                disabled={editing || !values["idArt"]}
                name="idFormulario"
                label="Formulario"
                options={formTypes}
                getOptions={() => dispatch(getFormTypes())}
              />
            </StyledArtFormConfiguration.StyledHorizontalInput>
          )}
          <StyledArtFormConfiguration.StyledHorizontalInput>
            <FormikSwitch
              name="ver"
              label="Ver"
            />
          </StyledArtFormConfiguration.StyledHorizontalInput>
          <StyledArtFormConfiguration.StyledHorizontalInput>
            <FormikSwitch
              name="crear"
              label="Crear"
            />
          </StyledArtFormConfiguration.StyledHorizontalInput>
          <StyledArtFormConfiguration.StyledHorizontalInput>
            <FormikSwitch
              name="editar"
              label="Editar"
            />
          </StyledArtFormConfiguration.StyledHorizontalInput>
          <StyledArtFormConfiguration.StyledHorizontalInput>
            <FormikSwitch
              name="borrar"
              label="Borrar"
            />
          </StyledArtFormConfiguration.StyledHorizontalInput>
        </>
      ) : (
        <CircularLoading />
      )}
    </>
  )
}

export default FormConfigurationForm;